import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Flag from './Flag';
import Logo from './Logo';

function Header({ language, onChangeLanguage, onOpenTerms, t }) {
    const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
    const languageMenuRef = useRef(null);
    const activeFlag = language === 'ru' ? 'ru' : 'gb';
    const activeLanguageLabel = language === 'ru' ? t('language.ru') : t('language.en');

    const changeLanguage = (next) => {
        onChangeLanguage(next);
        setLanguageMenuOpen(false);
    };

    useEffect(() => {
        if (!languageMenuOpen) return undefined;

        const closeOnOutsideClick = (event) => {
            if (!languageMenuRef.current?.contains(event.target)) setLanguageMenuOpen(false);
        };
        const closeOnEscape = (event) => event.key === 'Escape' && setLanguageMenuOpen(false);

        document.addEventListener('mousedown', closeOnOutsideClick);
        document.addEventListener('keydown', closeOnEscape);

        return () => {
            document.removeEventListener('mousedown', closeOnOutsideClick);
            document.removeEventListener('keydown', closeOnEscape);
        };
    }, [languageMenuOpen]);

    return (
        <header className="nav">
            <div className="content-width nav-content">
                <a href="#top" aria-label="FastProx home"><Logo /></a>
                <div className="nav-actions">
                    <button className="text-link" type="button" onClick={onOpenTerms}>{t('termsLink')}</button>
                    <div className="language-menu" ref={languageMenuRef}>
                        <button className="language-switch" type="button" onClick={() => setLanguageMenuOpen((open) => !open)} aria-haspopup="menu" aria-expanded={languageMenuOpen} aria-controls="language-options">
                            <Flag code={activeFlag} />
                            <span>{activeLanguageLabel}</span>
                            <svg viewBox="0 0 12 7" aria-hidden="true"><path d="m1 1 5 5 5-5" /></svg>
                        </button>
                        {languageMenuOpen && (
                            <div className="language-options" id="language-options" role="menu" aria-label="Language">
                                <button type="button" role="menuitem" className={language === 'ru' ? 'is-active' : ''} onClick={() => changeLanguage('ru')}>
                                    <Flag code="ru" />
                                    <span>{t('language.ru')}</span>
                                </button>
                                <button type="button" role="menuitem" className={language === 'en' ? 'is-active' : ''} onClick={() => changeLanguage('en')}>
                                    <Flag code="gb" />
                                    <span>{t('language.en')}</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
}

Header.propTypes = {
    language: PropTypes.oneOf(['ru', 'en']).isRequired,
    onChangeLanguage: PropTypes.func.isRequired,
    onOpenTerms: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default Header;
